export default "__VITE_ASSET__RKT$47_R__"